import { StyleSheet } from 'react-native';
import { Colors } from '../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
  },
  flatList: {
    marginBottom: 60,
  },
  products: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 19,
    color: 'black',
  },
  textBuy: {
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 18,
    maxWidth: 180,
    marginTop: 5,
    marginBottom: 20,
    color: Colors.GrayPallete.lightgrayThree,
  },
  columnFlat: {
    justifyContent: 'space-between',
  },
});
